import { fmt } from './bamsShortsUtils';

// Shared inventory badge: ATS on hand, QC hold, stuck in unusable locations, or nothing
// in the building. `v` is `{ ats, qc, unusable }`; a null `v` renders an em dash.
export function InventoryCell({ v }) {
    if (!v) return <span className="sm">—</span>;
    if (v.ats > 0)
        return (
            <span className="inv-ok">
                {fmt(v.ats)}
                <span className="subpct">on hand</span>
            </span>
        );
    if (v.qc > 0)
        return (
            <span className="inv-qc">
                QC {fmt(v.qc)}
                <span className="subpct">no ATS</span>
            </span>
        );
    if (v.unusable > 0)
        return (
            <span className="inv-qc">
                LOC {fmt(v.unusable)}
                <span className="subpct">no ATS</span>
            </span>
        );
    return (
        <span className="inv-none">
            none<span className="subpct">in building</span>
        </span>
    );
}
